export default __webpack_public_path__ + "static/media/maintanence3.d2ca925c.gif";